import React from "react";
import Header from "../Component/Header/Header";
import Footer from "../Component/Footer/Footer";
import { useEffect } from "react";

const RefundPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header />
      <div className="rs-breadcrumbs img4">
        <div className="breadcrumbs-inner text-center">
          <h1 className="page-title">Refund &amp; Cancellation</h1>
          {/* <ul>
            <li title="Welcome to Pay Pocket Vila">
              <a className="active" href="/">
                Home
              </a>
            </li>
            <li>Refund &amp; Cancellation</li>
          </ul> */}
        </div>
      </div>

      <div className="rs-team-Single pt-80 pb-60 md-pt-80 md-pb-60">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 pr-55 md-pr-15">
              <div className="project-con">
                <p>
                  Our focus is complete customer satisfaction. In the event, if
                  you are displeased with the services provided, we will refund
                  back the money, provided the reasons are genuine and proved
                  after investigation. Please read the fine prints of each deal
                  before buying it, it provides all the details about the
                  services or the product you purchase. In case of
                  dissatisfaction from our services, clients have the liberty to
                  cancel their projects and request a refund from us. Our Policy
                  for the cancellation and refund will be as follows:
                </p>
                <h4>Cancellation Policy</h4>
                <p>
                  For Cancellations please contact the us at
                  support@fusioncodes.in Requests received later than 7 business

                  
                  days prior to the end of the current service period will be
                  treated as cancellation of services for the next service
                  period.
                </p>
                <h4>Refund Policy</h4>
                <p>
                  We will try our best to provide best service to our user, In
                  case any client is not completely satisfied with our service
                  we can provide a refund. If paid by credit card, refunds will
                  be issued to the original credit card provided at the time of
                  purchase and in case of payment gateway name payments refund
                  will be made to the same account.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default RefundPolicy;
